import React from "react";

export default function StructuralComparisonTable() {
  return (
    <section className="bg-brand-charcoal text-brand-sand py-24 md:py-28 relative border-y-4 border-brand-orange overflow-hidden">
      <div className="absolute top-0 left-1/2 w-[800px] h-[800px] bg-brand-orange/[0.02] rounded-full blur-3xl pointer-events-none -translate-x-1/2" />
      
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-brand-espresso border border-brand-burgundy rounded-sm mb-4">
            <span className="text-brand-orange font-mono text-xs uppercase tracking-widest font-bold">
              3. Structural Comparison
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-white tracking-tight">
            The Economics of AI Leadership
          </h2>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse min-w-[800px]">
            <thead>
              <tr>
                <th className="p-4 border-b-2 border-brand-burgundy text-brand-orange font-mono text-xs uppercase tracking-widest font-bold w-1/4">
                  Service Dimension
                </th>
                <th className="p-4 border-b-2 border-brand-burgundy text-brand-sand/70 font-mono text-xs uppercase tracking-widest font-bold w-1/4">
                  Full-Time Executive
                </th>
                <th className="p-4 border-b-2 border-brand-burgundy text-brand-sand/70 font-mono text-xs uppercase tracking-widest font-bold w-1/4">
                  Generic Agency
                </th>
                <th className="p-4 border-b-2 border-brand-orange text-white font-mono text-sm uppercase tracking-widest font-bold w-1/4 bg-brand-espresso/30 rounded-t-sm">
                  Fractional CAIO / CTO
                </th>
              </tr>
            </thead>
            <tbody className="text-sm font-light">
              <tr className="hover:bg-brand-espresso/50 transition-colors">
                <td className="p-4 border-b border-brand-sand/10 font-bold text-white">
                  Capital Allocation
                </td>
                <td className="p-4 border-b border-brand-sand/10 text-brand-sand/80">
                  $400K+ Base + Equity
                </td>
                <td className="p-4 border-b border-brand-sand/10 text-brand-sand/80">
                  Hourly Billing Incentives
                </td>
                <td className="p-4 border-b border-brand-orange/30 text-white font-semibold bg-brand-espresso/30">
                  Fixed Advisory / $500K–$20M Scope Oversight
                </td>
              </tr>
              <tr className="hover:bg-brand-espresso/50 transition-colors">
                <td className="p-4 border-b border-brand-sand/10 font-bold text-white">
                  Architecture Standard
                </td>
                <td className="p-4 border-b border-brand-sand/10 text-brand-sand/80">
                  Dependent on In-House Skill
                </td>
                <td className="p-4 border-b border-brand-sand/10 text-brand-sand/80">
                  Rapid Prototyping / Wrapper Tools
                </td>
                <td className="p-4 border-b border-brand-orange/30 text-white font-semibold bg-brand-espresso/30">
                  Production-Grade GraphRAG & Rust Backends
                </td>
              </tr>
              <tr className="hover:bg-brand-espresso/50 transition-colors">
                <td className="p-4 border-b border-brand-sand/10 font-bold text-white">
                  Compliance Rigor
                </td>
                <td className="p-4 border-b border-brand-sand/10 text-brand-sand/80">
                  Internal Bias
                </td>
                <td className="p-4 border-b border-brand-sand/10 text-brand-sand/80">
                  Superficial Regex / Wrappers
                </td>
                <td className="p-4 border-b border-brand-orange/30 text-white font-semibold bg-brand-espresso/30">
                  Graph-Based Semantic Validation
                </td>
              </tr>
              <tr className="hover:bg-brand-espresso/50 transition-colors">
                <td className="p-4 border-b border-brand-sand/10 font-bold text-white">
                  Engagement Model
                </td>
                <td className="p-4 border-b border-brand-sand/10 text-brand-sand/80">
                  Permanent Overhead
                </td>
                <td className="p-4 border-b border-brand-sand/10 text-brand-sand/80">
                  Scope Creep Risk
                </td>
                <td className="p-4 border-b border-brand-orange/30 text-white font-semibold bg-brand-espresso/30 rounded-b-sm">
                  Embedded Executive Oversight
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
